export const ACTIONS_MAP_MARKETS = {
  ADD_MARKETS_PRODUCTS: 'ADD_MARKETS_PRODUCTS',
  CHANGE_MARKET_PRODUCT: 'CHANGE_MARKET_PRODUCT',
  REMOVE_MARKET_PRODUCT: 'CHANGE_MARKET_PRODUCT',
};

export const addMarketsProducts = (market = '', data) => ({
  type: ACTIONS_MAP_MARKETS.ADD_MARKETS_PRODUCTS,
  market,
  data,
});

export const changeMarketsProduct = (market = '', sku, data) => ({
  type: ACTIONS_MAP_MARKETS.CHANGE_MARKET_PRODUCT,
  market,
  sku,
  data,
});

export const removeMarketsProduct = () => ({
  type: ACTIONS_MAP_MARKETS.REMOVE_MARKET_PRODUCT,
});

